import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import NumberInput from '../../common/controls/numberInput';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const ContractSpecWetFilm = props => {
  const {
    onChange,
    active: {
      wetFilmThicknessMin,
      wetFilmThicknessMax,
      wetFilmThicknessUnits
    }
  } = props;
  const handleChangeWetFilmThicknessUnits = value => onChange('wetFilmThicknessUnits', value);
  const handleChangeWetFilmThicknessMin = value => onChange('wetFilmThicknessMin', value);
  const handleChangeWetFilmThicknessMax = value => onChange('wetFilmThicknessMax', value);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Wet Film Thickness"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Wet Film Thickness"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: wetFilmThicknessMin,
    entity: "ContractSpec",
    field: "wetFilmThicknessMin",
    onChange: handleChangeWetFilmThicknessMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: wetFilmThicknessMax,
    entity: "ContractSpec",
    field: "wetFilmThicknessMax",
    onChange: handleChangeWetFilmThicknessMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 6,
      offset: 6
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Mils', 'Microns'],
    values: [0, 1],
    label: "Thickness Units",
    allowNull: false,
    onChange: handleChangeWetFilmThicknessUnits,
    value: wetFilmThicknessUnits
  }))))));
};
ContractSpecWetFilm.propTypes = {
  active: PropTypes.shape({
    wetFilmThicknessMax: PropTypes.number,
    wetFilmThicknessMin: PropTypes.number,
    wetFilmThicknessUnits: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default ContractSpecWetFilm;